var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"chartdiv",staticClass:"hello",staticStyle:{"height":"230px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }